import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const PageNotFound = () => {
  useEffect(() => {
    const spans = document.querySelectorAll(".word span");

    const timers = [];

    spans.forEach((span, idx) => {
      const handleClick = (e) => {
        e.currentTarget.classList.add("active_page");
      };

      const handleAnimationEnd = (e) => {
        e.currentTarget.classList.remove("active_page");
      };

      span.addEventListener("click", handleClick);
      span.addEventListener("animationend", handleAnimationEnd);

      const timer = setTimeout(() => {
        span.classList.add("active_page");
      }, 750 * (idx + 1));

      timers.push(timer);
    });

    return () => {
      spans.forEach((span) => {
        span.replaceWith(span.cloneNode(true));
      });

      timers.forEach((timer) => clearTimeout(timer));
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Page Not Found | Xyncely</title>

        <meta
          name="description"
          content="The requested Xyncely page could not be found."
        />

        <meta
          name="robots"
          content="noindex, nofollow"
        />
      </Helmet>

      <main className="pagenotfound">
        <div className="word">
          <span>!</span>
          <span>4</span>
          <span>0</span>
          <span>4</span>
          <span>!</span>
        </div>

        <div className="goback">
          <div>!Error Page Not Found</div>

          <Link to="/">
            Go to home page
          </Link>
        </div>
      </main>
    </>
  );
};

export default PageNotFound;